module.exports = __webpack_public_path__ + "img/br3.db47e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br3.jpg
// module id = 0Xvl
// module chunks = 0